<template>
	<div id="lunchMenus">
		<tabs :options="{ useUrlFragment: false, defaultTabHash: selectedTab }">
			<tab :name="school.SCHOOL_TITLE"
					 v-for="(school, schoolIndex) in schools"
					 :key="`school_${schoolIndex}`"
					 :id="school.SCHOOL_ID">
				<template v-if="!!school">
					<calendar :selectedSchool="school"
										:key="`calendar_${school.SCHOOL_ID}_${schoolIndex}`">
					</calendar>
				</template>
			</tab>
		</tabs>
	</div>
</template>

<script>
	import Calendar from './shared/Calendar.vue';

	import { Tabs, Tab } from 'vue-tabs-component';
	import { mapGetters } from 'vuex';

	export default {
		name: 'LunchMenus',
		data() {
			return {
				loaded:						false,
				selectedTab:			null,
				schools:					[],
				selectedSchool:		{
					'GRADE_LEVEL':	'',
					'SCHOOL_TITLE': '',
					'SCHOOL_YEAR':	'',
					'SCHOOL_ID':		''
				}
			};
		},
		computed: {
			...mapGetters(['selectedStudent']),
			showFullCalendar() {
				return $(window).width() > 991;
			}
		},
		components: {
			Tabs,
			Tab,
			Calendar
		},
		methods: {
			getSchoolTitle() {
				return this.selectedSchool.SCHOOL_TITLE;
			}
		},
		created() {
			this.$store.commit('setTitleIcon', 'utensils');
			this.$store.commit('setTitle', this.$t('MAIN_CONTENT.LunchMenus.lunchMenusLabel'));
			this.$store.commit('setUseHeader', true);

			this.$set(this, 'schools', this.selectedStudent.ENROLLMENT);
		},
		mounted() {
			this.loaded = true;
		}
	}
</script>

<style scoped>
	@media (max-width: 767px) {
		.deskTop {
			display: none;
		}

		.mobile {
			display: inherit;
		}

		.fc-list-item-marker {
			display: none;
		}
	}

	@media (min-width: 768px)  and (max-width: 991px) {
		.deskTop {
			display: none;
		}

		.mobile {
			display: inherit;
		}

		.fc-list-item-marker {
			display: none;
		}
	}

	@media (min-width: 992px) and (max-width: 1199px) {
		.deskTop {
			display: inherit;
		}

		.mobile {
			display: none;
		}
	}

	@media (min-width: 1200px) {
		.deskTop {
			display: inherit;
		}

		.mobile {
			display: none;
		}
	}
</style>
